import { t } from 'i18next';
import * as yup from 'yup';

export const authSchema = () =>
  yup.object().shape({
    email: yup.string().label(t('labelEmail')).email().nullable().required(),
    password: yup.string().nullable(),
  });
